import React, { Component } from 'react';
import {Message,CardTextList,YyCard,YyMultiCard, Jump,JobCard} from './chatpanel/index';
import {actions, connect} from "@modules/wrap-redux/index";
import {MsgInFe} from "@config/MsgInFe";
import HistoryRecord from "@modules/historyRecord";
import {setlog} from "@modules/58m"
const Transform = require('@modules/transform');
const AlloyTouch = require('@modules/alloyTouch');
function judgeMsgInFE(msg){
  //判断msg是否属于前端配置
  let value = msg.value;
  for(var i = 0;i<MsgInFe.length;i++){
    for(var j= 0;j<MsgInFe[i].msg.length;j++){
      var word = MsgInFe[i].msg[j];
      if(value.search(word)>-1){
        //
        console.log("匹配");
        let result = JSON.parse(JSON.stringify(MsgInFe[i].reply.data));
        return result;
      }
    }
  }
  return false;
}

//wrap-redux
// WrapRedux.model({
//   name:"chatAreaData",
//   initialState:{
//     isFetching:false,
//     renderData:[]
//   },
//   reducers:{//参数1 state 参数2 action.data
//       addUserMsg(state,data){
//         let renderData = state.renderData.concat([data]);
//         return {
//           isFetching:true,
//           renderData,
//         }
//       },
//       addChatBotMsg(state,data){
//         setlogByMsg(data);
//         let renderData = state.renderData.concat(data);
//         return {
//           isFetching:false,
//           renderData,
//         }
//       },
//       addHistotyMsg(state,data){
//         let renderData = data.concat(state.renderData);
//         return {
//           isFetching:false,
//           renderData,
//         }
//       },
//       finishChatItem(state,data){
//         //这个actini的使用现在写在每个对话形式组件 没使用高阶组件 后续等hook出来 改为hook引用
//         state.renderData[data.index].isFinished = true;
//         return state;
//       }
//   },
//   effects:{
//     sendMsg:(msg)=>{
//       if(msg.value !="换一换"){
//         pageNum =1;
//       }else{
//         pageNum++;
//       }
//       let errInfo = [{type:1,returnMessage:"抱歉，小聘现在有点忙，请稍后再试试"}];
//       actions.chatAreaData.addUserMsg({data:msg});
//       let result = judgeMsgInFE(msg);
//       if(result){
//         //前端匹配了
//         return (dispatch,getState) =>{
//           setTimeout(function(){
//            let msg = createMsg({data:result},0)
//            actions.chatAreaData.addChatBotMsg({data:msg})
//           },700)
//          }
//       }
//       return (dispatch,getState) =>{
//         //去后端获取数据
//         msg.value = encodeURI(encodeURI(msg.value));
//         let url = `${dataApi.chat}?message=${msg.value}&pageNum=${pageNum}&platform=m`;
//         fetch(url,{
//           mode: 'cors',
//           credentials: 'include',
//           headers: {
//               'Content-Type': 'application/x-www-form-urlencoded'
//           },
//         })
//         .then(function(response) {
//             return response.text()
//         }).then(function(data) {
//               data = JSON.parse(data);
//               //console.log(data)
//               let msg;
//               if(data.code<=0){
//                 msg = createMsg({data:errInfo},0)
//               }else{
//                 msg = createMsg({data:data.data},0)
//               }
//               actions.chatAreaData.addChatBotMsg({data:msg});
//               if(data.tagOptions != undefined){
//                 actions.inputAreaData.refreshTag({data:data.tagOptions})
//               }
//         }).catch(function(){
//           let msg = createMsg({data:errInfo},0)
//           actions.chatAreaData.addChatBotMsg({data:msg});
//         })
//       }
//     }
//   }
// })


class ChatArea extends Component {
  
  constructor(props){
    super();
    this._alloyTouch = undefined;
  }

  componentDidUpdate(){
    //将chat区域滚动到合适位置 并且修改滚动min值
    let alloyTouch = this._alloyTouch;
    let scroller = document.querySelector('#scroller');
    //let header = document.querySelector('.module-header');
    let footer = document.querySelector('.module-userinput');
    let chatAreaShowHeight = document.querySelector('#scroller-wrap').clientHeight-footer.clientHeight;
    if(scroller.scrollHeight>chatAreaShowHeight){
      alloyTouch.min = chatAreaShowHeight-scroller.scrollHeight-20;
    }   
    alloyTouch.to(alloyTouch.min);
  }
  componentDidMount(){
    let scroller = document.querySelector('#scroller');
    Transform(scroller, true);
     this._alloyTouch = new AlloyTouch({
      touch:"#scroller-wrap",//反馈触摸的dom
      vertical: true,//不必需，默认是true代表监听竖直方向touch
      target: scroller, //运动的对象
      property: "translateY",  //被运动的属性
      min:0,
      //min: -scroller.scrollHeight+window.innerHeight-document.querySelector('.module-header').scrollHeight, //不必需,运动属性的最小值
      max: 0, //不必需,滚动属性的最大值
      sensitivity: 1,//不必需,触摸区域的灵敏度，默认值为1，可以为负数
      factor: 1,//不必需,表示触摸位移运动位移与被运动属性映射关系，默认值是1
      moveFactor: 1,//不必需,表示touchmove位移与被运动属性映射关系，默认值是1
      //step: 45,//用于校正到step的整数倍
      bindSelf: false,
      maxSpeed: 2, //不必需，触摸反馈的最大速度限制 
      initialValue: 0,
      change:function(value){  }, 
      touchStart:function(evt, value){
        document.querySelector("#userinput").blur();
       },
      touchMove:function(evt, value){  },
      touchEnd:function(evt,value){
        if(value>50) {
          setlog("mchatbot_records_pull");
          console.log('查看历史')
          let result = HistoryRecord.getHistoryRecord();
          if(result.length<=0){
            alert("已加载历史消息")
          }else{
            actions.chatAreaData.addHistotyMsg({data:result});
          }
        }
        if(value<-170){
          //判断是否需要提示LogoClickTip
          if(window.____globalCommonObjforFE.eventEmitter.listenerCount('showLogoClickTip')>0){
            window.____globalCommonObjforFE.eventEmitter.emit('showLogoClickTip');
          }
        }
      },
      tap:function(evt, value){  },
      pressMove:function(evt, value){  },
      animationEnd:function(value){  } //运动结束
    })
  }
  judgeRenderTpl(item,index){
    if(item.isUser && !item.isShow) return null;
    let tmp;
    switch(item.type){//1 文案 2 职位卡片 -1 求职课堂卡片  -2 春运单卡片 -3 春运多卡片 -4 跳转  负数是一期前端用的 没有做成可配 直接写死了 因为后续不一定会保留 目前rd那边只有 1 2 类型
      case 1:
      tmp=<Message message={item.label||item.returnMessage} rightItem={item.isUser?true:false} jumpLink={item.jumpLink} tel = {item.tel} key={index}></Message>;
      break;
      case 2:
      tmp=<JobCard {...item} rightItem={item.isUser?true:false} key={index}></JobCard>;
      break;
      case -1:
      tmp=<CardTextList key={index} ></CardTextList>;
      break;
      case -2:
      tmp=<YyCard key={index} {...item} ></YyCard>;
      break;
      case -3:
      tmp=<YyMultiCard key={index}></YyMultiCard>;
      break;
      case -4:
      tmp=<Jump key={index} index={index} history={this.props.history} {...item}></Jump>
      break;
      default:
      tmp=null;
    }
    return tmp;
  }

  render() {
    const {renderData,isFetching} = this.props.chatAreaData;
    console.log('渲染以下消息')
    return (
        <div className="module-chatarea">
          {
            renderData.map((item,index)=>{
              return this.judgeRenderTpl(item,index);
            })
          }
          {isFetching?<div className="loading-message"><span></span><span></span><span></span></div>:null}
      </div>
    );
  }
}
//The TC39 is changing the decorator proposal  so i do not change babel config to make old decorator syntax avilable
export default connect(state=>{
  return {
    chatAreaData:state.chatAreaData
  }
})(ChatArea);
